export default __webpack_public_path__ + "static/og-bb8b83e0f820559f81b0366bb8836ae8.png";